import { formatDuration } from 'date-fns'
import { de, enUS } from 'date-fns/locale'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { z } from 'zod/v4-mini'
import deTranslations from '@/locales/de.json'
import enTranslations from '@/locales/en.json'
import { appInsights } from './appInsights'

const key = 'app_language'
export const setLanguageLocalStorage = (language: string) =>
    localStorage.setItem(key, language)

export const getLanguageLocalStorage = () =>
    z.catch(z.optional(z.string()), undefined).parse(localStorage.getItem(key))

// eslint-disable-next-line import/no-named-as-default-member
export const t = await i18next.use(initReactI18next).init({
    lng: getLanguageLocalStorage(),
    fallbackLng: 'de',
    // Show debug information in local development.
    debug: import.meta.env.DEV,

    resources: {
        en: enTranslations,
        de: deTranslations,
    },
    interpolation: {
        escapeValue: false,
    },

    missingKeyHandler: (lngs, ns, key) => {
        appInsights.trackEvent({
            name: 'Missing Translation Key',
            properties: { lngs, ns, key },
        })
    },
    saveMissing: true,
})

export type TranslationFn = typeof t

const durationSchema = z.object({
    years: z.optional(z.number()),
    months: z.optional(z.number()),
    days: z.optional(z.number()),
    hours: z.optional(z.number()),
    minutes: z.optional(z.number()),
    seconds: z.optional(z.number()),
})

// Add a custom duration formatter to i18n.
i18next.services.formatter?.add('duration', (value, lng) => {
    try {
        // Try parsing the format options.
        const duration = durationSchema.parse(value)

        // Format duration.
        return formatDuration(duration, { locale: lng === 'de' ? de : enUS })
    } catch {
        // Otherwise return an empty string.
        console.warn('Passed value is not of type Duration.')
        return ''
    }
})
